import { ScraperInfoData } from './api.schema';
import { ScraperInfoUi, ScraperOperationUi } from './ui.schema';

const formatDateTime = (dateString: string | null | undefined): string | null => {
  if (!dateString) return null;
  try {
    let date: Date;

    const hasTimezone = dateString.endsWith('Z') ||
                       /[+-]\d{2}:\d{2}$/.test(dateString);

    if (hasTimezone) {
      date = new Date(dateString);
    } else {
      date = new Date(dateString + 'Z');
    }

    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } catch {
    return null;
  }
};

const formatDuration = (seconds: number | null | undefined): string | null => {
  if (!seconds && seconds !== 0) return null;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  } else if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  } else {
    return `${secs}s`;
  }
};

const extractErrorMessage = (error: unknown): string => {
  if (!error) return 'Error desconocido';

  if (typeof error === 'string') return error;

  if (error instanceof Error) return error.message;

  if (typeof error === 'object' && error !== null && 'message' in error) return String((error as Record<string, unknown>).message);

  if (typeof error === 'object' && error !== null && 'detail' in error) return String((error as Record<string, unknown>).detail);

  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
};

const parseOperaciones = (jsonMetadata: Record<string, string> | null | undefined): ScraperOperationUi[] => {
  if (!jsonMetadata) return [];

  return Object.entries(jsonMetadata).map(([titulo, estado]) => ({
    titulo: titulo.trim().replace(/^- /, ''),
    exito: estado.includes('\u2705')
  }));
};

export const transformScraperInfoApiToUi = (data: ScraperInfoData): ScraperInfoUi => {
  const hasError = !!data.error;

  return {
    id: data.id ?? null,
    fechaInicio: data.fecha_inicio ?? null,
    fechaFin: data.fecha_fin ?? null,
    totalTimeSeg: data.total_time_seg ?? null,
    fechaInicioFormatted: formatDateTime(data.fecha_inicio),
    fechaFinFormatted: formatDateTime(data.fecha_fin),
    totalTimeFormatted: formatDuration(data.total_time_seg),
    operaciones: parseOperaciones(data.json_metadata),
    hasError,
    error: hasError ? extractErrorMessage(data.error) : null
  };
};

export * from './api.schema';
export * from './ui.schema';
